export const Operators = {
  And: 'and',
  Min: 'min',
  None: 'none',
  Or: 'or'
};
